import React from 'react';
import { mockBio } from '../mockData';
import { useLanguage } from '../context/LanguageContext';
import './About.css';

const bioEs = `Mi obra explora la belleza escondida en el caos.

A través de la abstracción, la textura y el trazo instintivo, creo paisajes emocionales que surgen de la intuición más que de la planeación.

Cada pieza es una conversación entre el silencio y el movimiento — un reflejo de emociones, recuerdos y fragmentos que no siempre pueden expresarse con palabras.

Como arquitecta, pintora y escultora, me acerco al arte como un acto de descubrimiento.

Permito que la mente hable libremente, abrazando la imperfección, la espontaneidad y las conexiones invisibles que aparecen a lo largo del proceso creativo.`;

export const About = () => {
  const { t, lang } = useLanguage();
  const bio = lang === 'es' ? bioEs : mockBio;

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-content">
          <div className="about-header">
            <h2 className="section-title">{t('about_title')}</h2>
          </div>
          
          <div className="about-text">
            <p className="bio-text">{bio}</p>
          </div>
        </div>

        <div className="about-image-section">
          <div className="about-image-wrapper">
            <img 
              src="https://customer-assets.emergentagent.com/job_studio-llaguno/artifacts/k1zwup2w_WhatsApp%20Image%202026-05-28%20at%2010.47.51%20AM.jpeg" 
              alt="C. Llaguno"
              className="about-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
